"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ProductVariant = void 0;
require("./ProductVariant.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ProductVariant component
 *
 * @method
 * @param { ProductVariantProps} props
 * @returns ProductVariant
 */

const ProductVariant = props => {
  const {
    externalMedia,
    swatchImage,
    variantTypeLabel,
    variantTypeDescription,
    variant = defaultProps.variant,
    swatchImages
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-ProductVariant', `pal-c-ProductVariant--${variant}`);
  const hasContent = [variantTypeLabel, variantTypeDescription, swatchImage, externalMedia, swatchImages && swatchImages.length > 0].some(Boolean);
  if (!hasContent) return null;
  const getMediaContent = () => {
    switch (variant) {
      case 'multi':
        {
          if (swatchImages?.length) {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "pal-c-ProductVariant--swatches"
            }, swatchImages.map((swatchImage, index) => /*#__PURE__*/_react.default.createElement(_Image.default, {
              key: `pal-c-ProductVariant--swatch-${index}`,
              ariaHidden: true,
              desktopImage: swatchImage.imageUrl,
              altText: ""
            })));
          }
          return null;
        }
      case 'default':
      default:
        {
          if (swatchImage?.imageUrl) {
            return /*#__PURE__*/_react.default.createElement(_Image.default, {
              ariaHidden: true,
              desktopImage: swatchImage.imageUrl,
              altText: ""
            });
          }
          return null;
        }
    }
  };
  const getExternalMediaContent = () => {
    if (variant === 'multi') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-ProductVariant--swatches"
      }, (0, _renderObject.renderObject)(externalMedia));
    }
    return (0, _renderObject.renderObject)(externalMedia);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, variantTypeLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label-sm"
  }, variantTypeLabel), externalMedia && getExternalMediaContent(), !externalMedia && getMediaContent(), variantTypeDescription && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "label-sm"
  }, variantTypeDescription));
};

/**
 * Property type definitions
 * @typedef ProductVariantProps
 * @type {object}
 * @property {string} variantTypeLabel - sets the product variant label - Color:
 * @property {object} swatchImage - sets the swatch image before the description label
 * @property {string} variantTypeDescription - sets the description text for the product variant
 * @property {object} externalMedia - accepts a single media object (default) or an object with mapped array of media objects (multi)
 * @property {('default'|'multi')} variant - Sets the variant of the component
 * @property {array} swatchImages - Accepts array of swatch images to render for multi variant
 */
exports.ProductVariant = ProductVariant;
const propTypes = exports.propTypes = {
  /**
   * accepts a single media object (default) or an object with mapped array of media objects (multi)
   */
  externalMedia: _propTypes.default.object,
  /**
   * sets the swatch image object
   * See Image object for more detail ../Image/Image.jsx
   */
  swatchImage: _propTypes.default.object,
  /**
   * sets the product variant type label
   */
  variantTypeLabel: _propTypes.default.string,
  /**
   * sets the description text for the product variant
   */
  variantTypeDescription: _propTypes.default.string,
  /**
   * Sets the variant of the component
   */
  variant: _propTypes.default.oneOf(['default', 'multi']),
  /**
   * Accepts array of swatches to render for multi variant
   * - ** NOTE: Design recommendation is to pass minimum of 2 and maximum of 6 swatches to display **
   */
  swatchImages: _propTypes.default.array
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} variant='default' - Sets the default variant of the component
 */
const defaultProps = exports.defaultProps = {
  variant: 'default'
};
ProductVariant.propTypes = propTypes;
var _default = exports.default = ProductVariant;